export const roadmapData = [
  {
    id: 'q1-agentic-workflows',
    quarter: 'Q1 2025',
    title: 'Core Agentic Workflow Development',
    description: 'Establish foundational agentic workflows for code understanding, generation, and task automation. Focus on modular design for future extensions.',
    keyPoints: [
        "Develop core AI agent capabilities for code analysis and generation.",
        "Define standardized workflow interfaces and communication protocols between agents.",
        "Pilot with internal tools for basic code understanding and simple refactoring tasks."
    ],
    status: 'Planned'
  },
  {
    id: 'q2-ide-integration',
    quarter: 'Q2 2025',
    title: 'IDE Integration (VS Code & JetBrains Focus)',
    description: "Develop extensions for popular IDEs (VS Code, JetBrains suite) to bring Artemis capabilities directly into the developer's environment, leveraging established agentic workflows for real-time assistance.",
    keyPoints: [
        "Release beta plugins for VS Code and IntelliJ IDEA.",
        "Enable features like on-demand code explanation, and contextual suggestions.",
        "Gather early user feedback for iterative improvements."
    ],
    status: 'Planned'
  },
  {
    id: 'q3-cicd-integration',
    quarter: 'Q3 2025',
    title: 'CI/CD Pipeline Integration',
    description: "Integrate Artemis into CI/CD pipelines (e.g., Jenkins, GitHub Actions, GitLab CI) for automated code analysis, quality checks, and optimization suggestions during the build and deployment process.",
    keyPoints: [
        "Develop connectors for major CI/CD platforms.",
        "Allow configuration of automated Artemis scans and reports within pipelines.",
        "Provide actionable feedback to development teams directly from CI/CD results."
    ],
    status: 'Planned'
  },
  {
    id: 'q3-mcp-support',
    quarter: 'Q3 2025',
    title: 'Multi-Cloud Platform (MCP) Awareness - Phase 1',
    description: "Extend Artemis to understand and provide initial support for code targeting major multi-cloud platforms (AWS, Azure, GCP). Focus on recognizing platform-specific APIs and configurations.",
    keyPoints: [
        "Build knowledge base of common services and APIs for AWS, Azure, GCP.",
        "Enable Artemis to identify cloud-specific constructs in codebases.",
        "Lay groundwork for platform-specific optimization advice in future phases."
    ],
    status: 'Planned'
  },
  {
    id: 'q4-agentic-swarm',
    quarter: 'Q4 2025',
    title: 'Advanced Code Optimization with Agent Swarms',
    description: "Implement sophisticated, multi-agent (swarm) strategies for complex code optimization tasks. Agents will collaborate to explore solution spaces, test hypotheses, and propose validated improvements for performance, security, and maintainability.",
    keyPoints: [
        "Design and implement a scalable agent swarm architecture.",
        "Develop algorithms for collaborative problem-solving and knowledge sharing among agents.",
        "Benchmark optimization capabilities on diverse and complex codebases.",
        "Integrate human-in-the-loop feedback for guiding and validating swarm optimizations."
    ],
    status: 'Planned'
  }
]; 